import { render, staticRenderFns } from "./RuleCustomListProImport.vue?vue&type=template&id=2198103c&scoped=true"
import script from "./RuleCustomListProImport.vue?vue&type=script&lang=js"
export * from "./RuleCustomListProImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198103c",
  null
  
)

export default component.exports